// "Pro Eintrag erfassen" Zulagen are entered per allocation / entry block, so their
// hours may not exceed that row's own work time — the server refuses the save
// otherwise (PerEntryAllowanceHours). Here the browser says so before the round
// trip: each such hours input gets a native `max`, which blocks the submit with
// the browser's own message and marks the field.
//
// The max is floored to two decimals so it never allows what the server refuses
// (289 min is 4.8167 h: 4.82 would pass a rounded max and fail on save).
import { entryBlocks, entryNetMinutes } from "./timesheet_net_time"

const HOURS_INPUT = "input[data-per-entry-allowance-hours]"

// Sets the limit on every per-entry hours input inside +row+; a row without a
// known duration yet (blank hours, incomplete times) gets none.
export function limitPerEntryAllowanceHours(row, minutes) {
  row.querySelectorAll(HOURS_INPUT).forEach((input) => {
    if (!minutes || minutes <= 0) {
      input.removeAttribute("max")
    } else {
      input.max = String(Math.floor((minutes / 60) * 100) / 100)
    }
  })
}

// Every multi-entry block of +root+ against its own net time. Blocks resolving to
// the form itself (no multi-entry wrapper) are left alone: they are no row.
export function limitEntryBlockAllowanceHours(root) {
  entryBlocks(root).forEach(({ element, values }) => {
    if (element === root) return

    limitPerEntryAllowanceHours(element, entryNetMinutes(values))
  })
}
